import type { DomainSchema, PdfCardDef } from '../types';
import { esc } from '../pdf-helpers';

export const SKILLS = {
  priority: true,
  cardTitle: '{skillName}',
  fields: {
    skillName: { type: 'text', label: 'Skill' },
    endorsementCount: { type: 'number', label: 'Endorsements' },
    addedAt: { type: 'date', hidden: true },
  },
  // skillName is the card title; only supplementary fields appear in rows
  layout: [[]],
  editLayout: [[{ field: 'skillName' }]],
} satisfies DomainSchema;

export const SkillsPdfCard: PdfCardDef = {
  styles: `
    .skill-pills { display: flex; flex-wrap: wrap; gap: 5px; }
    .skill-pill { padding: 4px 10px; background: #f0efee; border-radius: 20px; font-size: 11px; color: var(--body); }
    .skill-pill.skill-hl { background: var(--accent-soft); color: #2a7a6c; font-weight: 700; }
    .skill-count { font-size: 9px; opacity: 0.55; font-weight: 400; margin-left: 2px; }
  `,
  render(records) {
    if (!records.length) return '';
    const sorted = [...records].sort(
      (a, b) => ((b['endorsementCount'] as number) || 0) - ((a['endorsementCount'] as number) || 0)
    );
    const topN = Math.ceil(sorted.length / 3);
    const pills = sorted
      .map((r, i) => {
        const cls = i < topN ? 'skill-pill skill-hl' : 'skill-pill';
        const count = r['endorsementCount']
          ? `<span class="skill-count">${r['endorsementCount']}</span>`
          : '';
        return `<span class="${cls}">${esc(r['skillName'])}${count}</span>`;
      })
      .join('');
    return `<div class="skill-pills">${pills}</div>`;
  },
};
